<template>
  <div class="annotations-logs">
    <v-dialog
      v-model="filterDialog"
      width="70vw"
      height="80vh"
    >
      <v-card>
        <v-card-actions class="annotations-logs__close-button">
          <DsButton
            v-tooltip="closeLabel"
            color="tertiary"
            name="close"
            :icon="true"
            @click="filterDialog = false"
          />
        </v-card-actions>
        <div class="annotations-logs__internal-style">
          <MultiSelectFilter
            v-model="selectedOperators"
            class="mr-3"
            :select-items="getOptions"
            :label="usersLabel"
            :searchable="true"
          />
          <v-text-field
            v-model="selectedPids"
            class="mr-3"
            deletable-chips
            chips
            :label="callIdLabel"
          />
          <div class="annotations-logs__buttons">
            <DsButton
              v-tooltip="filterLabel"
              class="ma-2 annotations-logs__button"
              color="secondary"
              name="filter"
              :icon="true"
              @click="applyFilter"
            />
            <br>
            <DsButton
              v-tooltip="trashLabel"
              class="ma-2 annotations-logs__button"
              color="secondary"
              name="trash"
              :icon="true"
              @click="resetFilter"
            />
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      width="70vw"
      height="80vh"
    >
      <v-card>
        <v-card-actions class="annotations-logs__close-button">
          <DsButton
            v-tooltip="closeLabel"
            color="tertiary"
            name="close"
            :icon="true"
            @click="dialog = false"
          />
        </v-card-actions>
        <v-card-text class="modal-style">
          <h3>{{ this.$t('components.OperatorsLogs.faq6.title') }}</h3>
          <p>{{ this.$t('components.OperatorsLogs.faq6.description') }}</p>

          <h3>{{ this.$t('components.OperatorsLogs.faq7.title') }}</h3>
          <p>{{ this.$t('components.OperatorsLogs.faq7.description') }}</p>

          <h3>{{ this.$t('components.OperatorsLogs.faq3.title') }}</h3>
          <p>{{ this.$t('components.OperatorsLogs.faq3.description') }}</p>

          <h3>{{ this.$t('components.OperatorsLogs.faq4.title') }}</h3>
          <p>{{ this.$t('components.OperatorsLogs.faq4.description') }}</p>

          <h3>{{ this.$t('components.OperatorsLogs.faq5.title') }}</h3>
          <p>{{ this.$t('components.OperatorsLogs.faq5.description') }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="postDialog"
      fullscreen
    >
      <v-card>
        <v-toolbar>
          <v-toolbar-title>{{ this.$t('components.OperatorsLogs.details') }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <StIcon
              class="close-icon"
              icon-name="close"
              @click="closeCard"
            />
          </v-toolbar-items>
        </v-toolbar>
        <v-card-actions>
          <PostThemeAndSentiment :post="post" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <GenericChart
      :request-status="requestStatus"
      :title="title"
      :map-keys="mapKeys"
      :items="exportedItems"
      :open-dialog="openDialog"
      :open-filter="openFilter"
      :item-id="itemId"
      :has-custom-filter="true"
      class="make-a-copy"
      v-bind="$attrs"
      @reload="getData"
    />
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :loading="inputLoading"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      class="table-truncate"
    >
      <template v-slot:item.pid="{ item }">
        <DsButton
          v-tooltip="viewLabel"
          class="annotations-logs__clean-sla-buttons"
          color="secondary"
          name="view"
          :icon="true"
          @click="openCard({ pid: item.pid })"
        />
      </template>
      <template v-slot:item.sacCallId="{ item }">
        <div
          v-tooltip="item.pid"
        >
          {{ item.pid }}
        </div>
      </template>
      <template v-slot:item.username="{ item }">
        <div
          v-tooltip="item.username"
        >
          {{ item.username }}
        </div>
      </template>
      <template v-slot:item.channel="{ item }">
        <div
          v-tooltip="item.channel"
        >
          {{ item.channel }}
        </div>
      </template>
      <template v-slot:item.field="{ item }">
        <div
          v-tooltip="item.field"
        >
          {{ item.field }}
        </div>
      </template>
      <template v-slot:item.operation="{ item }">
        <div
          v-tooltip="item.operation"
        >
          {{ item.operation }}
        </div>
      </template>
      <template v-slot:item.newValue="{ item }">
        <div
          v-tooltip="item.newValue"
        >
          {{ item.newValue }}
        </div>
      </template>
      <template v-slot:item.oldValue="{ item }">
        <div
          v-tooltip="item.oldValue"
        >
          {{ item.oldValue }}
        </div>
      </template>
      <template v-slot:item.createdAt="{ item }">
        <div
          v-tooltip="item.createdAt"
        >
          {{ item.createdAt }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import GenericChart from '@/components/cards/models/GenericChart';
import PostThemeAndSentiment from '@/components/Post/PostThemeAndSentiment';
import { mapActions, mapGetters, mapState } from 'vuex';
import EventBus from '@/utils/event-bus';
import MultiSelectFilter from '@/components/filter/MultiSelectFilter.vue';
import { DsButton } from '@ds/components';
import WarRoomService from '@/services/WarRoomService';
import sacTypeModel from '@/mixins/sac-type-model';
import channelModel from '@/mixins/channel-model';
import OperatorsLogs from '@/language/pt/components/OperatorsLogs';

export default {
  name: 'AnnotationsLogs',
  components: {
    GenericChart,
    MultiSelectFilter,
    DsButton,
    PostThemeAndSentiment,
  },
  mixins: [
    sacTypeModel,
    channelModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      options: {
        itemsPerPage: 5,
        page: 1,
      },
      footerProps: {
        'items-per-page-options': [5, 10, 15, 20, 50],
      },
      exportLimit: 2000,
      items: [],
      exportedItems: [],
      totalItems: 0,
      requestStatus: 'loading',
      dialog: false,
      postDialog: false,
      filterDialog: false,
      post: null,
      selectedOperators: null,
      selectedPids: null,
    };
  },
  computed: {
    filterLabel() {
      return this.$t('components.OperatorsLogs.filterLabel');
    },
    trashLabel() {
      return this.$t('components.OperatorsLogs.trashLabel');
    },
    viewLabel() {
      return this.$t('components.OperatorsLogs.viewPost');
    },
    openChatLabel() {
      return this.$t('components.OperatorsLogs.openChatLabel');
    },
    closeLabel() {
      return this.$t('components.OperatorsLogs.closeLabel');
    },
    usersLabel() {
      return this.$t('components.OperatorsLogs.users');
    },
    callIdLabel() {
      return this.$t('components.OperatorsLogs.pids');
    },
    mapKeys() {
      return {
        username: this.$t('components.OperatorsLogs.username'),
        pid: this.$t('components.OperatorsLogs.pid'),
        channel: this.$t('components.OperatorsLogs.channel'),
        field: this.$t('components.OperatorsLogs.annotatedField'),
        operation: this.$t('components.OperatorsLogs.operation'),
        oldValue: this.$t('components.OperatorsLogs.oldValue'),
        newValue: this.$t('components.OperatorsLogs.newValue'),
        createdAt: this.$t('components.OperatorsLogs.date'),
      };
    },
    ...mapGetters('dashboard', [
      'activeDashboardFilters',
      'activeDashboard',
    ]),
    ...mapGetters('filter', [
      'getStartDateInMilliseconds',
      'getEndDateInMilliseconds',
      'getEndDate',
    ]),
    ...mapState('filter', [
      'accountId',
      'universeId',
    ]),
    ...mapState('dashboard', [
      'isStaging',
    ]),
    inputLoading() {
      return this.requestStatus === 'loading';
    },
    getOptions() {
      return this.activeDashboardFilters?.repliers?.map(res => res.name) || [];
    },
    headers() {
      return [
        {
          text: this.$t('components.OperatorsLogs.username'),
          value: 'username',
        },
        {
          text: this.$t('components.OperatorsLogs.pid'),
          value: 'sacCallId',
        },
        {
          text: this.$t('components.OperatorsLogs.channel'),
          value: 'channel',
        },
        { text: this.$t('components.OperatorsLogs.field'), value: 'field' },
        {
          text: this.$t('components.OperatorsLogs.operation'),
          value: 'operation',
        },
        {
          text: this.$t('components.OperatorsLogs.oldValue'),
          value: 'oldValue',
        },
        {
          text: this.$t('components.OperatorsLogs.newValue'),
          value: 'newValue',
        },
        {
          text: this.$t('components.OperatorsLogs.date'),
          value: 'createdAt',
        },
        { text: this.$t('components.OperatorsLogs.viewPost'), value: 'pid' },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getOperatorsLogsService',
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      this.getExportData();
      this.applyFilter(options);
    },
    filter() {
      if (!this.items[0]) {
        return [];
      }
      return this.items;
    },
    defaultParams() {
      const startingAt = this.getStartDateInMilliseconds;
      const endingAt = this.getEndDateInMilliseconds;
      const usernames = this.selectedOperators ? this.selectedOperators.value.join('", "') : null;
      const pids = this.selectedPids ? this.selectedPids.split(' ').join('').split(',').join('", "') : null;

      return {
        startingAt,
        endingAt,
        usernames,
        pids,
      };
    },
    async getExportData() {
      this.exportedItems = [];
      this.getOperatorsLogsService({
        itemId: this.itemId,
        servicePath: 'getOperatorsLogs',
        serviceParams: {
          starting_at: this.defaultParams().startingAt,
          ending_at: this.defaultParams().endingAt,
          usernames: this.defaultParams().usernames,
          pids: this.defaultParams().pids,
          annotations_limit: this.exportLimit,
        },
      })
        .then(response => {
          this.exportedItems = this.responseHandler(response);
        })
        .catch((e) => {
          console.error(e);
          this.requestStatus = 'error';
        });
    },
    applyFilter(options) {
      this.filterDialog = false;
      this.dialogFilter = false;
      this.requestStatus = 'loading';
      this.items = [];

      this.getOperatorsLogsService({
        itemId: this.itemId,
        servicePath: 'getOperatorsLogs',
        serviceParams: {
          starting_at: this.defaultParams().startingAt,
          ending_at: this.defaultParams().endingAt,
          usernames: this.defaultParams().usernames,
          pids: this.defaultParams().pids,
          offset: (this.options.page - 1) * this.options.itemsPerPage,
          annotations_limit: this.options.itemsPerPage,
        },
      })
        .then(response => {
          this.totalItems = response.total;
          this.items = this.responseHandler(response);
          this.requestStatus = 'success';
          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((e) => {
          console.error(e);
          this.requestStatus = 'error';
        });
    },
    translateValues(item) {
      item.channel = OperatorsLogs[item.channel.toLowerCase()];
      item.operation = OperatorsLogs[item.operation.toLowerCase()];
      item.field = OperatorsLogs[item.field.toLowerCase()];
    },
    timeHandler(item) {
      const date = new Date(item.createdAt).toLocaleString('pt-br');
      item.createdAt = date;
    },
    responseHandler(response) {
      const data = response.annotations.map(item => {
        this.translateValues(item);
        this.timeHandler(item);
        return item;
      });
      return data;
    },
    resetFilter() {
      this.selectedOperators = null;
      this.selectedPids = null;
      this.applyFilter();
    },
    openDialog() {
      this.dialog = true;
    },
    openFilter() {
      this.filterDialog = true;
    },
    getId(text) {
      return text.replace(/<\/?u>/giu, '').replace('.pdf', '').split('<br>')[0];
    },
    async openCard({ pid, sacCallId }) {
      this.$attrs.filter = { pids: [pid] };
      this.$attrs.filterId = null;
      const defaultParams = {
        date_range: `200001010000:${this.getEndDate}`,
        account_id: this.accountId,
        universe_id: this.universeId,
        is_staging: this.isStaging,
        limit: 1,
        channel: 'importedData',
        filter: {
          is_sac: false,
        },
      };
      pid ? (defaultParams.filter.pids = { value: [pid] }) : (defaultParams.filter.sac_call_ids = { value: [sacCallId] });
      WarRoomService.topPosts({ params: defaultParams })
        .then(res => {
          if (!res.posts[0]) {
            this.postDialog = false;
          } else {
            this.postDialog = true;
            this.post = res.posts[0];
          }
        }).catch(err => console.error(err));
    },
    closeCard() {
      this.postDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.annotations-logs {
  &__internal-style {
    width: 100%;
    padding: 1rem;
    display: flex;
  }

  &__button {
    box-shadow: none;
    border-radius: unset;
  }

  &__buttons {
    display: flex;
  }

  &__close-button {
    display: flex;
    flex: end;
    justify-content: flex-end;
  }

  &__clean-sla-buttons {
    box-shadow: none;
    border-radius: unset;
    margin-left: 20%;
  }
}

::v-deep {
  .table-truncate {
    td {
      max-width: 10vw;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .modal-style {
    * {
      color: var(--ds-color-snow) !important;
    }

    h3 {
      font-weight: var(--ds-font-weight-bold);
    }
  }

  .close-icon {
    height: var(--ds-spacing-stack-lg);
    padding-top: var(--ds-spacing-stack-lg);
  }

  .v-dialog {
    overflow-x: hidden;
  }
}
</style>
